module.exports = __webpack_public_path__ + "static/media/volume-icon.eaeee802.svg";